module.exports = __webpack_public_path__ + "img/us-2.53904f3f.webp";